






































































import { Component, Prop, Vue } from "vue-property-decorator";
import { channels as tv } from "@/config/host.config";
import { deleteElement } from "@/api/delite/delite-element";
import { IDictionary } from "@/@types/dictionary";

import DictionaryCard from "../card/dictionary-card.vue";
import DictionaryForm from "../forms/dictionary-form.vue";
import RecuclerDictionaryCard from "../card/recucler-dictionary-card.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    DictionaryCard,
    DictionaryForm,
    RecuclerDictionaryCard,
  },
})
export default class Dictionary extends Vue {
  @Prop({ type: Array, default: () => [] }) dictionaryList!: Array<IDictionary>;
  @Prop({ type: String, default: "forms" }) parent!: string;

  id = "";
  tabIndex = 0;
  editingCard: IDictionary | null = null;

  switchTab(idx: number): void {
    this.tabIndex = idx;
    if (idx === 0) this.$parent.$emit("deleted", false);
    else if (idx === 1) this.$parent.$emit("deleted", true);
    if (idx !== 2) this.editingCard = null;
  }

  editCT(card: IDictionary): void {
    this.editingCard = card;
    this.tabIndex = 2;
  }

  afterMutation(): void {
    this.$emit("reload");
  }

  onError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("error.empty400")),
      type: "warn",
    });
  }

  async deleteCT(id: string): Promise<void> {
    if (!id) return this.onError();

    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("ChannelsPage.form.contentType.delete")),
        }
      );

      if (result === true) {
        const uri = tv.content_type;
        deleteElement(id, uri)
          .then(() => {
            this.$emit("deleteContentType", id);
            this.$notify({
              group: "global",
              text: String(this.$i18n.t("error.200")),
            });
            this.afterMutation();
          })
          .catch(() => {
            this.onError();
          });
      }
    } catch {
      this.onError();
    }
  }

  async updateCT(data: Partial<IDictionary>, id: string): Promise<void> {
    const idParam = id ? id : this.id;
    const method = idParam ? "put" : "post";
    const url = idParam ? `${tv.content_type}/${idParam}` : tv.content_type;

    try {
      const ctRes = await this.$axios({
        method,
        url,
        data,
      });

      if (ctRes.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.$emit("changeContentType", idParam, data);
        this.id = "";
        this.editingCard = null;
        this.tabIndex = 0;
        this.$parent.$emit("deleted", false);
        this.afterMutation();
      }
    } catch (error) {
      this.onError();
    }
  }
}
